import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { CommonService } from 'src/app/shared/services/common.service';
import { EtlService } from '../../vault-data-migration-etl/etl.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { UntypedFormGroup } from '@angular/forms';
import { ValidationConfigurationFormComponent } from '../validation-configuration-form/validation-configuration-form.component';
import { EditButton } from 'src/app/shared/common/Editbutton';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';

export interface FormData {

  migrationId: 0,
  dnsId: 0,
  state: string,
  screenType: string
}
export interface prevalidateconfiguration {

  propertyname: string,
  propertytype: string,
  expectedvalue: string,
  validationlogic,
  migrationid: number,
  dnsid: number,
  retrievaltype: string,
  validationtype: string,
  actualvalue: string,
  validationnote: string,
  validationstatus: string
}
@Component({
    selector: 'app-validateconfiguration-popup',
    templateUrl: './validateconfiguration-popup.component.html',
    styleUrls: ['./validateconfiguration-popup.component.scss'],
    standalone: false
})

export class ValidateconfigurationPopupComponent implements OnInit {
  components = {
    buttonRenderer: EditButton,

  }

  retrievalTypeOptions:any = [];
  propertyTypeList:any = []
  defaultData = []
  gridDataA = []
  backgroundColorButton: string;
  btnName: string;
  backgroundColorScreen: string;
  loadpageSize: any;
  value;
  loadcurrentPage;
  loadtotalPages;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  rowClassRules
  loadlastPage: any;
  loadnextPage: any;
  loadnextPagePlusOne: any;
  dnsId;
  migrationId;
  totalData: any = []
  defaultColDef = [
    {
      headerName: '',
      headerTooltip: 'select the property',
      field: 'checkbox',
      filter: 'agTextColumnFilter',
      width: 50,
      cellStyle: (params) => {
        // Check the 'status' column value and disable the checkbox if 'status' is 'No'
        if (params.data.status === 'No') {

          return { 'pointer-events': 'none', opacity: 0.5 };
        }
        return null; // Return null to use the default styling for other rows
      },
      checkboxSelection: (params) => {
        // Check the 'status' column value and disable the checkbox if 'status' is 'No'
        if (params.data.status === 'No') {
          return false;
        }
        return true;
      },
      headerCheckboxSelection:true
    },
    {
      headerName: 'Property Name',
      headerTooltip: 'Property Name',
      tooltipValueGetter: (params) => 'Description : ' + params.value,
      field: 'propertyname',
      filter: 'agTextColumnFilter',
      width: 250,
      cellStyle: (params) => {
        // Check the 'status' column value and disable the checkbox if 'status' is 'No'
        if (params.data.status === 'No') {
          return { 'pointer-events': 'none', opacity: 0.5 };
        }
        return null; // Return null to use the default styling for other rows
      },
      editable: true
    },
    {
      headerName: 'Expected Value',
      headerTooltip: 'Expected Value',
      tooltipValueGetter: (params) => 'Description : ' + params.value,
      field: 'expectedvalue',
      filter: 'agTextColumnFilter',
      width: 300,
      cellStyle: (params) => {
        // Check the 'status' column value and disable the checkbox if 'status' is 'No'
        if (params.data.status === 'No') {
          return { 'pointer-events': 'none', opacity: 0.5 };
        }
        return null; // Return null to use the default styling for other rows
      },
      editable: true
    },
    {
      headerName: 'Validation Logic',
      headerTooltip: 'Validation Logic',
      tooltipValueGetter: (params) => 'Description : ' + params.value,
      field: 'validationlogic',
      filter: 'agTextColumnFilter',
      width: 600,
      cellStyle: (params) => {
        // Check the 'status' column value and disable the checkbox if 'status' is 'No'
        if (params.data.status === 'No') {
          return { 'pointer-events': 'none', opacity: 0.5 };
        }
        return null; // Return null to use the default styling for other rows
      },
      editable: true
    },
    {
      headerName: 'Retrieval Type',
      headerTooltip: 'Retrieval Type',
      tooltipValueGetter: (params) => 'Description : ' + params.value,
      field: 'retrievaltype',
      filter: 'agTextColumnFilter',
      width: 200,
      editable: true,
      cellStyle: (params) => {
        // Check the 'status' column value and disable the checkbox if 'status' is 'No'
        if (params.data.status === 'No') {
          return { 'pointer-events': 'none', opacity: 0.5 };
        }
        return null; // Return null to use the default styling for other rows
      },
      cellEditor: 'agSelectCellEditor', // Use the built-in select cell editor
      cellEditorParams: {
        values: this.retrievalTypeOptions.lookupcode,
      },
    },
    {
      headerName: 'Action',
      headerTooltip: 'Edit',
      cellRenderer: 'buttonRenderer',
      filter: false,
      pinned: 'left',
      lockPinned: true,
      width: 80,
      cellRendererParams: {

        edit: this.editData.bind(this)

      },
    },

  ]
  vaultvalidationAPI: any;
  gridColumnAPI: any;
  gridAPIA: any;
  gridDataB: any[];
  gridAPIB: any;
  gridDataC: any[];
  gridAPIC: any;
  gridDataD: any[];
  gridAPID: any;
  dataExtractioType: string;
  defualtScreen: boolean;
  validationScreen: boolean;
  afterValidationData: prevalidateconfiguration[] = [];
  displayedColumns: string[] = ['propertyname', 'expectedvalue', 'actualvalue', 'validationstatus', 'validationnote'];
  successCount: number;
  failureCount: number;
  gridACount: number;
  gridBCount: number;
  gridCCount: number;
  gridDCount: number;


  constructor(@Inject(MAT_DIALOG_DATA) public data: FormData,
    private errorMssg: ErrorMessages, private spinner: NgxUiLoaderService,
    private snackBar: MatSnackBar, private commonService: CommonService, private service: EtlService,
    private localStorageSettings: LocalStorageSettingsService, public dialogref: MatDialogRef<ValidateconfigurationPopupComponent>,
    public formDialogRef: MatDialogRef<ValidationConfigurationFormComponent>, private dialog: MatDialog,
    private cdr: ChangeDetectorRef
    ) { }


  ngOnInit(): void {
    this.commonService.getlookupVauleByLookUpType("retrievalType").subscribe(result=>{
      console.log(result);
      this.retrievalTypeOptions = result;
    })
    this.commonService.getlookupVauleByLookUpType("propertyType").subscribe(result=>{
      console.log(result);
      this.propertyTypeList = result;
    })
    this.successCount = 0;
    this.failureCount = 0;
    if (this.data.screenType == 'default') {
      this.defualtScreen = true
      this.validationScreen = false
    }
    else {
      this.defualtScreen = false;
      this.validationScreen = true;
    }
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    this.btnName = 'Validate Configurations'
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    let state = this.data.state
    if (state == 'In Progress') {
      console.log(this.data)
      this.dnsId = this.data.dnsId;
      this.migrationId = this.data.migrationId;
    }


  }
  closePopUp() {
    this.dialogref.close();
  }
  gridOptions = {
    rowSelection: 'multiple',
    onSelectionChanged: this.onSelectionChanged.bind(this),

    // Add other grid options as needed
  }
  onSelectionChanged() {
    //const selectedRows = this.gridOptions.api.getSelectedRows();
    // Implement logic to handle selected rows (e.g., highlight them)
  }
  //this function is for going to the given page number
  onloadSearchChange(searchValue: number) {
    this.gridAPIA.paginationGoToPage(searchValue - 1);
    this.gridAPIB.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onloadPageSizeChanged(newPageSize) {
    var value = this.loadpageSize;
    this.gridAPIA.setGridOption('paginationPageSize', Number(value));
    this.gridAPIB.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onloadBtNext() {
    console.log("next")
    this.gridAPIA.paginationGoToNextPage();
    this.gridAPIB.paginationGoToNextPage();
  }

  // below function for going to previous page
  onloadBtPrevious() {
    console.log("previous")
    this.gridAPIA.paginationGoToPreviousPage();
    this.gridAPIB.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onloadBtFirst() {
    this.gridAPIA.paginationGoToFirstPage();
    this.gridAPIB.paginationGoToFirstPage();
  }

  // below function for going to last page
  onloadBtLast() {
    this.gridAPIA.paginationGoToLastPage();
    this.gridAPIB.paginationGoToLastPage();

  }
  onloadPaginationChanged() {
    if (this.gridAPIA) {
      this.loadlastPage = this.gridAPIA.paginationIsLastPageFound();
      this.loadcurrentPage = this.gridAPIA.paginationGetCurrentPage() + 1
      this.loadnextPage = this.gridAPIA.paginationGetCurrentPage() + 1 + 1
      this.loadnextPagePlusOne = this.gridAPIA.paginationGetCurrentPage() + 1 + 1 + 1
      this.loadtotalPages = this.gridAPIA.paginationGetTotalPages()
    }
    if (this.gridAPIB) {
      this.loadlastPage = this.gridAPIB.paginationIsLastPageFound();
      this.loadcurrentPage = this.gridAPIB.paginationGetCurrentPage() + 1
      this.loadnextPage = this.gridAPIB.paginationGetCurrentPage() + 1 + 1
      this.loadnextPagePlusOne = this.gridAPIB.paginationGetCurrentPage() + 1 + 1 + 1
      this.loadtotalPages = this.gridAPIB.paginationGetTotalPages()
    }
  }
  retrieveInstructionsBasedOnPropertyType(params) {
    this.spinner.start()
    try {
      this.vaultvalidationAPI = params;
      this.gridDataA = []
      this.gridDataB = []
      this.gridDataC = []
      this.gridDataD = []
      this.gridAPIA = params.api


      this.gridColumnAPI = params.columnApi

      this.service.retrievePreValidateConfiguration(this.dnsId, 0).subscribe(res => {
        if (res != undefined || res.length != 0) {
          
          for (const element of res) {
            console.log("result: "+element.status)
            if (element.propertytype == 'General') {
              this.gridDataA.push(element);
            }
            else if (element.propertytype == 'Extraction') {
              this.gridDataB.push(element)
            }
            else if (element.propertytype == 'Transformation') {
              this.gridDataC.push(element);
            }
            else if (element.propertytype == 'Load') {
              this.gridDataD.push(element);
            }
            else {
              console.log(element)
            }
          }
          this.gridAPIA.refreshCells();
          this.gridAPIA.redrawRows();
          this.gridAPIA.setGridOption('rowData', this.gridDataA)
          this.gridAPIB.setGridOption('rowData', this.gridDataB)
          this.gridAPIB.redrawRows();
          this.gridAPIC.setGridOption('rowData', this.gridDataC)
          this.gridAPIC.redrawRows();
          this.gridAPID.setGridOption('rowData', this.gridDataD)
          this.gridAPID.redrawRows();
          
          this.cdr.detectChanges();


        }


      })
    } catch (error) {
      console.log(error)
      this.spinner.stop();
    }
    this.spinner.stop();
  }

  validateProperties() {
    this.spinner.start()
    try {
      console.log('GRID A : ', this.gridAPIA.getSelectedRows())
      console.log('GRID B : ', this.gridAPIB.getSelectedRows())
      console.log('GRID C : ', this.gridAPIC.getSelectedRows())
      console.log('GRID D : ', this.gridAPID.getSelectedRows())


      this.gridAPIA.getSelectedRows().map(arr => {
        if(arr['status']!='No'){
          this.totalData.push(arr)
        }
        
      })
      this.gridAPIB.getSelectedRows().map(arr => {
        if(arr['status']!='No'){
          this.totalData.push(arr)
        }
      })
      this.gridAPIC.getSelectedRows().map(arr => {
        if(arr['status']!='No'){
          this.totalData.push(arr)
        }
      })
      this.gridAPID.getSelectedRows().map(arr => {
        if(arr['status']!='No'){
          this.totalData.push(arr)
        }
      })
      console.log('Total : ', this.totalData)
      if (this.totalData.length == 0) {
        alert("Please select at least one property to validate.");
        this.spinner.stop();
      }
      else {
        this.service.validateConfigurations(this.dnsId, this.migrationId, this.totalData).subscribe(res => {
          if (res['error'] == true) {

            this.snackBar.open("Something went wrong", "Ok", { duration: 5000 })
          }
          else {
            this.retrieveDataForTable();
            console.log(res)
          }

        })

      }


    } catch (error) {
      console.log(error)
      this.snackBar.open("Something went wrong", "Ok", { duration: 5000 })
      this.spinner.stop()
    }




  }

  retrieveInstructionsExtraction(params) {
    this.vaultvalidationAPI = params;
    this.gridAPIB = params.api
    this.gridAPIB.setGridOption('rowData', this.gridDataB)
  }
  retrieveInstructionsForTransformation(params) {
    this.vaultvalidationAPI = params;
    this.gridAPIC = params.api
    this.gridAPIC.setGridOption('rowData', this.gridDataC)
  }
  retrieveInstructionsForLoad(params) {
    this.vaultvalidationAPI = params;
    this.gridAPID = params.api
    this.gridAPID.setGridOption('rowData', this.gridDataD)
  }

  retrieveDataForTable() {
    this.defualtScreen = false;
    this.validationScreen = true;
    this.spinner.start()
    try {
      this.service.retrievePreValidateConfiguration(this.dnsId, this.migrationId).subscribe(res => {
        if (res == undefined || res.length == 0) {
          this.snackBar.open("the resultdata is null.please try again", "Ok", { duration: 5000 })
          this.spinner.stop();
        }
        else {

          this.afterValidationData = res;
          this.afterValidationData.forEach(arr => {
            if (arr['validationstatus'] == 'true') {
              this.successCount += 1;
            }
            else {
              this.failureCount += 1;
            }
          })
          this.spinner.stop();
        }
      })
    } catch (error) {
      console.log(error)
      this.spinner.stop()
    }

  }


  addPreValidationConfiguration() {

    let dialogref = this.dialog.open(ValidationConfigurationFormComponent, {
      maxWidth: '100vw',
      height: '83%',
      width: "45%",
      data: { formType: "save", objectData: undefined },
      disableClose: true
    })
    dialogref.afterClosed().subscribe(result => {
      console.log('The dialog was closed' + result);
      if (result != undefined) {
        if (result) {
          console.log("save success")
          this.spinner.start()
          this.retrieveInstructionsBasedOnPropertyType(this.vaultvalidationAPI)
          this.spinner.stop();
        }
      }
    })

  }
  editData(e) {

    console.log(e)
    let dialogref = this.dialog.open(ValidationConfigurationFormComponent, {
      maxWidth: '100vw',
      height: '83%',
      width: "45%",
      data: { formType: "edit", objectData: e.rowData },
      disableClose: true
    })
    dialogref.afterClosed().subscribe(result => {
      console.log('The dialog was closed' + result);
      if (result != undefined) {
        if (result) {
          console.log("updated success")
          this.spinner.start()
          this.retrieveInstructionsBasedOnPropertyType(this.vaultvalidationAPI)
          this.spinner.stop();
        }
      }
    })
  }

  refreshAllGrids(){
    this.spinner.start()
    this.retrieveInstructionsBasedOnPropertyType(this.vaultvalidationAPI)
    this.spinner.stop()
  }
}
